import React from "react"

// Layout
import Layout from "../components/layout"
// Components
import Menu from "../components/home/menu"
import Breadcrumb from "../components/elements/breadcrumb"
import AudioGrid from "../components/elements/audio-grid"
// Hooks
import { useAsmetHome } from "../hooks/use-asmet-home"
import { useAsmetAudios } from "../hooks/use-asmet-audios"

const AudiosPage = () => {
  const asmetHome = useAsmetHome()
  const allAudios = useAsmetAudios()

  const crumbs = [
    { path: `/media`, label: "Media" },
    { path: `/audios`, label: "Audios" },
  ]

  let flattenAudios = []
  allAudios.forEach(el => {
    flattenAudios = flattenAudios.concat(Object.values(el))
  })

  return (
    <Layout meta={{ og_titulo: "Audios" }}>
      <div id="asm-template-header" className="contanier-fluid pt-3 pb-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <Breadcrumb crumbs={crumbs} />
              <h3 className="text-white-alpha text-left pt-4">Galería de Audios</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="asm-media-main container my-5">
        <AudioGrid allAudios={flattenAudios} />
      </div>
      <hr />
      <Menu menuSecundario={asmetHome.menu_secundario}/>
    </Layout>
  )
}

export default AudiosPage
